import React from 'react';
import PropTypes from 'prop-types';

import {IconClose20, IconDelete20, IconOverflowMenu20,} from 'pac-ux-components';

import {Button, Menu} from '@mantine/core';


import {IconContext} from 'react-icons';

import {AiOutlineLogout} from 'react-icons/ai';

import {I18n} from '@aws-amplify/core';

export const SmallProfileOverflowMenu = ({
                                             onSignOut,
                                             icon,
                                             iconTitle,
                                             onSignOutAndForget,
                                             onHideAccount,
                                         }) => {
    return (
        <Menu shadow="md">
            <Menu.Target>
                <Button variant="subtle" color="gray">
                    <IconOverflowMenu20/>
                </Button>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item icon={icon} onClick={onSignOut}>
                    {iconTitle}
                </Menu.Item>
                <Menu.Item
                    icon={<IconClose20 size={20}/>}
                    onClick={onHideAccount}
                >
                    {I18n.get('Forget')}
                </Menu.Item>
                <Menu.Item
                    icon={<IconDelete20 size={20}/>}
                    onClick={onSignOutAndForget}
                >
                    {I18n.get('Sign out and Forget')}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

SmallProfileOverflowMenu.propTypes = {
    onSignOut: PropTypes.func,
    icon: PropTypes.object,
    iconTitle: PropTypes.string,
    onSignOutAndForget: PropTypes.func,
    onHideAccount: PropTypes.func,
};

SmallProfileOverflowMenu.defaultProps = {
    // icon: <IconClose24 />,
    icon: (
        <IconContext.Provider value={{size: '20px', color: '#2a7fc9'}}>
            <AiOutlineLogout/>
        </IconContext.Provider>
    ),
    iconTitle: I18n.get('Sign out'),
};
